import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = {
  id: "header",
  class: "mx-auto flex max-w-3xl items-center justify-between py-1.5"
}
const _hoisted_2 = { class: "flex items-center justify-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "250",
  class: "h-auto",
  title: "Open Galaxy"
}, null, -1)
const _hoisted_4 = { id: "networkgate" }
const _hoisted_5 = { class: "invisible" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NetworkGate = _resolveComponent("NetworkGate")!
  const _component_Languages = _resolveComponent("Languages")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/')
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_NetworkGate, { expectedNetwork: _ctx.chainId }, null, 8, ["expectedNetwork"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Languages)
    ])
  ]))
}